<template>
    <div class="comment-dialog">
        <md-dialog :md-active.sync="application_comment_dialog.show">
            <div class="md-layout">
                <!-- Stage & Status -->
                <edit-loan-comments 
                    ref="editComment"
                    v-model="application"
                    :available-sections="availableSections"
                    @save_application="(resolve, reject) => saveApplication().then(resolve).catch(reject)"
                />
            </div>

            <md-dialog-actions>
                <md-button
                    class="md-primary md-simple"
                    @click="onCloseUpdateStatusDialog"
                >
                    Cancel
                </md-button>
                <!-- <loading-icon-text-button
                    @click="saveApplication"
                    icon="save"
                    :loading="saving"
                    :disabled="saving"
                >
                    Save
                </loading-icon-text-button> -->
            </md-dialog-actions>
        </md-dialog>
        <md-dialog-alert
            :md-active.sync="error_dialog.show"
            :md-title="error_dialog.title"
            :md-content="error_dialog.content"
        />
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import { GroupCard } from "@/components";
import ValidatedInputs from "@/components/ValidatedInput";
import ButtonGroupInput from "@/components/ValidatedInput/ButtonGroupInput.vue";
import ApplicationList from "@/components/ApplicationList";
import LoadingIconTextButton from "@/components/LoadingIconTextButton";
import EditLoanStatus from "@/components/Editors/EditLoanStatus";
import filters from "@/components/utils/filters";
import EditLoanComments from "../Editors/EditLoanComments";
export default {
    components: {
        GroupCard,
        ...ValidatedInputs,
        ButtonGroupInput,
        ApplicationList,
        LoadingIconTextButton,
        EditLoanStatus,
        EditLoanComments
    },
    props: {},
    data() {
        return {
            saving: false,
            error_dialog: {
                show: false,
                title: '',
                content: '',
            },
        };
    },
    computed: {
        ...mapGetters([
            "application",
            "user",
            "userHasPermission",
            "application_comment_dialog"
        ]),
        permissions() {
            return this.application_comment_dialog &&
                this.application_comment_dialog.application
                ? this.application_comment_dialog.application.permissions
                : null;
        },
        availableSections(){
            return  [
                "Loan",
                "Loan - Owners",
                "Loan - Details",
                "Applicant",
                "Applicant - Personal",
                "Applicant - Personal - Contact Details",
                "Applicant - Personal - Current Address",
                "Applicant - Personal - Credit Report",
                "Applicant - Addresses",
                "Applicant - Addresses - Landlord",
                "Applicant - Addresses - Previous",
                "Applicant - Employment",
                "Applicant - Employment - Current",
                "Applicant - Employment - Previous",
                "Applicant - Employment - Other Incomes",
                "Applicant - Employment - Spouses Details",
                "Applicant - Document Requests",
                "Applicant - Living Expenses",
                "Applicant - Assets & Liabilities",
                "Applicant - References",
                "Wallet Notification"
            ]
        }
    },
    methods: {
        onCloseUpdateStatusDialog() {
            this.$store.commit("set_application_comment_dialog", null);
        },
        async saveApplication() {
            this.$refs.editComment.updateComments();
            let is_open_application = this.application_comment_dialog.application.id == this.$store.getters.application_status.id;
            try {
                this.saving = true;
                await axios.post(
                    `/api/v1/application`,
                    this.application
                );
                this.$store.commit("set_work_basket", null);
                if (is_open_application) {
                    //remove application dirty state
                    this.$store.commit("setApplicationStatus", {
                        dirty: false
                    });
                    await this.$store.dispatch("reload_application");
                }
                this.onCloseUpdateStatusDialog();
            } catch (error) {
                this.error_dialog.title = "Failed to save Application";
                this.error_dialog.content = `The following error occurred: ${error.response.data}`;
                this.error_dialog.show = true;
                throw error;
            }
            this.saving = false;
        }
    },
    filters: {
        ...filters
    },
    created() {
    }
};
</script>
<style scoped>
::v-deep .md-dialog-container {
    overflow: visible;
}
::v-deep .comment-card {
    margin-top: 0px;
    box-shadow: none;
}
::v-deep .comment-card .table-container {
    max-height: 400px;
}
</style>
